import { Reducer, combineReducers } from 'redux'
import { createReducer } from '@cbgms/base/utils/redux'
import * as types from './types'
import { ISupplierOrderDetail } from '@cbgms/api/modules/supplier-orders'

export type SupplierOrderDetailState = Readonly<ISupplierOrderDetail> | null
const defaultState: SupplierOrderDetailState = null

// eslint-disable-next-line carsys-custom/typescript-prefer-interface-extend-over-intersection
type SupplierOrderDetailReducerBehavior<S> = Record<typeof types.LOAD_SUPPLIER_ORDER_DETAIL_SUCCESS, Reducer<S, any>> &
  Record<typeof types.CLEAR_SUPPLIER_ORDER_DETAIL, Reducer<S, any>>

const detail = createReducer<SupplierOrderDetailState, SupplierOrderDetailReducerBehavior<SupplierOrderDetailState>>(defaultState, {
  [types.LOAD_SUPPLIER_ORDER_DETAIL_SUCCESS]: (_, { payload }) => {
    return {
      ...payload.data
    }
  },
  [types.CLEAR_SUPPLIER_ORDER_DETAIL]: () => {
    return null
  }
})

export interface SupplierOrdersReducerState {
  detail: SupplierOrderDetailState
}

const supplierOrders = combineReducers<SupplierOrdersReducerState>({
  detail
})

export default supplierOrders
